import { publicListDocumentCategories } from "../lib/documents";

type Category = {
	id: number;
	nombre: string;
	slug: string;
	descripcion?: string | null;
	allowMultiplePublished: boolean;
	defaultSortMode?: "date_asc" | "date_desc" | "title_asc" | "title_desc";
	isActive: boolean;
	publishedDocumentsCount?: number | string;
};

const root = document.querySelector(".docs-page") as HTMLElement | null;
const tenantId = Number(root?.dataset.tenantId || 1);
const grid = document.getElementById("categories-grid") as HTMLDivElement | null;

function escapeHtml(value: unknown) {
	return String(value ?? "")
		.replaceAll("&", "&amp;")
		.replaceAll("<", "&lt;")
		.replaceAll(">", "&gt;")
		.replaceAll('"', "&quot;")
		.replaceAll("'", "&#39;");
}

function getDescription(category: Category) {
	if (category.descripcion?.trim()) return category.descripcion.trim();

	return "Consultá la documentación disponible dentro de esta categoría.";
}

function render(rows: Category[]) {
	if (!grid) return;

	if (!rows.length) {
		grid.innerHTML = `<p class="empty">Aún no hay categorías publicadas.</p>`;
		return;
	}

	grid.innerHTML = rows
		.map((category) => {
			const href = `/documentos/${encodeURIComponent(category.slug)}`;

			return `
				<article class="category-card">
					<div class="category-card__icon" aria-hidden="true">
						<svg viewBox="0 0 24 24" fill="none">
							<path
								d="M8 3.75h6.5l4.75 4.75V19.5A1.75 1.75 0 0 1 17.5 21h-11A1.75 1.75 0 0 1 4.75 19.5v-14A1.75 1.75 0 0 1 6.5 3.75H8Z"
								stroke="currentColor"
								stroke-width="1.7"
								stroke-linejoin="round"
							/>
							<path
								d="M14.5 3.75V8.5h4.75"
								stroke="currentColor"
								stroke-width="1.7"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M8 12h8M8 15.5h8"
								stroke="currentColor"
								stroke-width="1.7"
								stroke-linecap="round"
							/>
						</svg>
					</div>

					<div class="category-card__body">
						<h3>${escapeHtml(category.nombre)}</h3>
						<p>${escapeHtml(getDescription(category))}</p>

						<div class="category-card__actions">
							<a href="${href}" class="ghost-button">Ver documentos</a>
						</div>
					</div>
				</article>
			`;
		})
		.join("");
}

async function load() {
	if (!grid) return;

	try {
		grid.innerHTML = `<p class="empty">Cargando categorías…</p>`;

		const rows = await publicListDocumentCategories(tenantId);
		render(Array.isArray(rows) ? rows : []);
	} catch (err) {
		console.error(err);
		grid.innerHTML = `<p class="empty">No se pudieron cargar las categorías.</p>`;
	}
}

void load();